<template>
  <ComboPicker
    :label="orientation == 'horizontal' ? null : label"
    strings="tipo"
    icon="mdi-tune"
    :bothIcons="orientation == 'horizontal'"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todos os tipos' : '(Todos)'"
    types="grouped-items"
    :tags="[]"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Tipo de Registro' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  data() {
    return {
      allItems: [
        { id: 'association', name: 'Associação (veículo)' },
        { id: 'associateTicket', name: 'Associação (ticket)' },
        { id: 'creation', name: 'Criação' },
        { id: 'lease', name: 'Concessão' },
        { id: 'firmwareUpdate', name: 'FW Update' },
        { id: 'installation', name: 'Instalação, Retirada, Intervenção' },
        { id: 'logistic', name: 'Logística' },
        { id: 'troubleshooting', name: 'Problemas' },
        { id: 'rename', name: 'Troca de Placa' },
        { id: 'checklist', name: 'Checklist de Verificação' },
        { id: 'loss', name: 'Extravio' }
      ]
    }
  }
}
</script>

<style></style>
